<template>
<div>
  <Loader v-if="spaceLoading || postLoading" />
  <PostView  :isShareSpace="true"  :postID="lastPost.id" v-if="lastPost" />

  <div v-else-if="post_error != null || error != null">
    <NotFound /> 
  </div>
</div>
</template>

<script>
import Loader from "../components2/loader.vue";
import PostView from "./post-view.vue";
import NotFound from "../components2/not-found.vue";

export default {
  components: {
    Loader: Loader,
    PostView: PostView,
    NotFound: NotFound,
  },
  props: {
    zip: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$store.dispatch("shares/getSpace", this.zip);
  },
  computed: {
    space() {
      return this.$store.getters["shares/space"];
    },
    lastPost() {
      return this.$store.getters["shares/post"];
    },
    spaceLoading() {
      return this.$store.state.shares.space.fetching;
    },
    postLoading() {
      return this.$store.state.shares.post.fetching;
    },
    error() {
      return this.$store.state.shares.space.errorCode;
    },
    post_error() {
      return this.$store.state.shares.post.errorCode;
    },
  },
};
</script>

<style scoped>
.no-post-message {
  color: #a5a5a5;
  font-size: 25px;
}
</style>